// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"page-primaryButton-GBIKnk","pageHeaderWrapper":"page-pageHeaderWrapper-1lRmaX","pageHeader":"page-pageHeader-2iy_hU","pageWrapper":"page-pageWrapper-2RYI8p"};